import { createStore } from 'redux';
import rootReducer from './reducers';

const store = createStore(
  rootReducer,
  (window as any).__REDUX_DEVTOOLS_EXTENSION__ &&
  (window as any).__REDUX_DEVTOOLS_EXTENSION__() // Redux DevTools extension setup
);

export default store;
